module.exports = __webpack_public_path__ + "img/cafeamplatzlogonew.f4f44d9d.png";